module.exports = __webpack_public_path__ + "static/media/how_are_you.45e0022c.png";